import React from 'react';
import { endMeeting } from 'flow/actions/meeting-actions';
import { swapCall } from 'flow/actions/phone-actions';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import {
    selectChatName,
    selectMemberInChat,
} from 'flow/selectors/chat-selectors';
import {
    selectActiveMeetingCallSessionStartTime,
    selectActiveMeetingChatSessionId,
    selectActiveMeetingIsOnHold,
    selectActiveMeetingMembersFirstNames,
    selectActiveMeetingViewIsMinimized,
    selectMeetingIsInFocus,
} from 'flow/selectors/meeting-selectors';
import { getFirstThreeMembersNames } from 'flow/utils/meeting-utils';
import MeetingLargeCallItem from './MeetingLargeCallItem';
import MeetingSmallCallItem from './MeetingSmallCallItem';

interface Props {
    focusedCallHungUp?: boolean;
}

const MeetingCallItem: React.FC<Props> = ({ focusedCallHungUp }) => {
    const dispatch = useAppDispatch();

    const chatSessionId = useAppSelector(selectActiveMeetingChatSessionId);
    const memberInChat = useAppSelector((state) =>
        selectMemberInChat(state, chatSessionId),
    );
    const chatName = useAppSelector((state) =>
        selectChatName(state, chatSessionId),
    );
    const isOnHold = useAppSelector(selectActiveMeetingIsOnHold);
    const meetingIsFocused = useAppSelector(selectMeetingIsInFocus);
    const meetingCallStartTime = useAppSelector(
        selectActiveMeetingCallSessionStartTime,
    );
    const membersFirstNames = useAppSelector(
        selectActiveMeetingMembersFirstNames,
    );
    const isMinimizedView = useAppSelector(selectActiveMeetingViewIsMinimized);

    const numberOfMembers = membersFirstNames.length + 1;
    const displayNames = getFirstThreeMembersNames(membersFirstNames);

    if (!meetingIsFocused || focusedCallHungUp || isMinimizedView) {
        return (
            <MeetingSmallCallItem
                memberInChat={memberInChat}
                chatName={chatName}
                meetingCallStartTime={meetingCallStartTime}
                numberOfMembers={numberOfMembers}
                displayNames={displayNames}
                isOnHold={isOnHold}
                doHangup={() => dispatch(endMeeting())}
                onSwap={() => dispatch(swapCall())}
                isMinimized={isMinimizedView}
            />
        );
    }

    return (
        <MeetingLargeCallItem
            memberInChat={memberInChat}
            numberOfMembers={numberOfMembers}
            chatName={chatName}
            displayNames={displayNames}
            meetingCallStartTime={meetingCallStartTime}
        />
    );
};

export default MeetingCallItem;
